import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    typeText: '',
    List: [],
    Page: '',
    Value: '',
    Value1: '',
    id: '',
    ComId: '',
    ListShu: [],
    PageShu: '',
    InputShu: '',
    ListXuan: [],
    PageXuan: '',
    InputXuan: '',
    InputZhao: '',
    YueId: '',
    Videourl: '',
    ListActivity: [],
    PageActivity: '',
    InputActivity: '',
    Index: '',
    Index1: '',
    ListShuType: [],
    ListXuanType: [],
    LineXuan: '',
    LineShu: '',
    IIndex: '',
    IIndex1: '',
    NewsId: '',
    catch_components: [],
  },
  mutations: {
    GET_CATCHE_COMPONENTS(state, val) {
      state.catch_components = val
      localStorage.setItem("catch_components", val);
    },
    updataTypeText(state, val) {
      state.typeText = val;
      localStorage.setItem("typeText", val);
    },
    updataList(state, val) {
      state.List = val;
      sessionStorage.setItem("List", val);
    },
    updataPage(state, val) {
      state.Page = val;
      sessionStorage.setItem("Page", val);
    },
    updataIndex(state, val) {
      state.Index = val;
      sessionStorage.setItem("Index", val);
    },
    updataIndex1(state, val) {
      state.Index1 = val;
      sessionStorage.setItem("Index1", val);
    },
    updataValue(state, val) {
      state.Value = val;
      sessionStorage.setItem("Value", val);
    },
    updataValue1(state, val) {
      state.Value1 = val;
      sessionStorage.setItem("Value1", val);
    },
    updataDetailId(state, val) {
      state.id = val;
      sessionStorage.setItem("id", val);
    },
    updataComId(state, val) {
      state.ComId = val;
      sessionStorage.setItem("ComId", val);
    },
    updataDetailYueId(state, val) {
      state.YueId = val;
      sessionStorage.setItem("YueId", val);
    },
    updataListShu(state, val) {
      state.ListShu = val;
      sessionStorage.setItem("ListShu", val);
    },
    updataPageShu(state, val) {
      state.PageShu = val;
      sessionStorage.setItem("PageShu", val);
    },
    updataListShuType(state, val) {
      state.ListShuType = val;
      sessionStorage.setItem("ListShuType", val);
    },
    updataListXuanType(state, val) {
      state.ListXuanType = val;
      sessionStorage.setItem("ListXuanType", val);
    },
    updataInputShu(state, val) {
      state.InputShu = val;
      sessionStorage.setItem("InputShu", val);
    },
    updataLineShu(state, val) {
      state.LineShu = val;
      sessionStorage.setItem("LineShu", val);
    },
    updataLineXuan(state, val) {
      state.LineXuan = val;
      sessionStorage.setItem("LineXuan", val);
    },
    updataListXuan(state, val) {
      state.ListXuan = val;
      sessionStorage.setItem("ListXuan", val);
    },
    updataPageXuan(state, val) {
      state.PageXuan = val;
      sessionStorage.setItem("PageXuan", val);
    },
    updataInputXuan(state, val) {
      state.InputXuan = val;
      sessionStorage.setItem("InputXuan", val);
    },
    updataInputZhao(state, val) {
      state.InputZhao = val;
      sessionStorage.setItem("InputZhao", val);
    },
    updataVideourl(state, val) {
      state.Videourl = val;
      sessionStorage.setItem("Videourl", val);
    },
    updataListActivity(state, val) {
      state.ListActivity = val;
      sessionStorage.setItem("ListActivity", val);
    },
    updataPageActivity(state, val) {
      state.PageActivity = val;
      sessionStorage.setItem("PageActivity", val);
    },
    updataInputActivity(state, val) {
      state.InputActivity = val;
      sessionStorage.setItem("InputActivity", val);
    },
    updataIIndex(state, val) {
      state.IIndex = val;
      sessionStorage.setItem("IIndex", val);
    },
    updataIIndex1(state, val) {
      state.IIndex1 = val;
      sessionStorage.setItem("IIndex1", val);
    },
    updataNewsId(state, val) {
      state.NewsId = val;
      sessionStorage.setItem("NewsId", val);
    },

  },
  actions: {
    setTypeText({ commit }, val) {
      commit("updataTypeText", val);
    },
  },
  getters: {
    getTypeText: (state) => {
      return state.typeText || localStorage.getItem("typeText");
    },
    getList: (state) => {
      return state.List || sessionStorage.getItem("List");
    },
    getPage: (state) => {
      return state.Page || sessionStorage.getItem("Page");
    },
    getValue: (state) => {
      return state.Value || sessionStorage.getItem("Value");
    },
    getValue1: (state) => {
      return state.Value1 || sessionStorage.getItem("Value1");
    },
    getId: (state) => {
      return state.id || sessionStorage.getItem("id");
    },
    getComId: (state) => {
      return state.ComId || sessionStorage.getItem("ComId");
    },
    getListShu: (state) => {
      return state.ListShu || sessionStorage.getItem("ListShu");
    },
    getListShuType: (state) => {
      return state.ListShuType || sessionStorage.getItem("ListShuType");
    },
    getListXuanType: (state) => {
      return state.ListXuanType || sessionStorage.getItem("ListXuanType");
    },
    getPageShu: (state) => {
      return state.PageShu || sessionStorage.getItem("PageShu");
    },
    getInputShu: (state) => {
      return state.InputShu || sessionStorage.getItem("InputShu");
    },
    getLineXuan: (state) => {
      return state.LineXuan || sessionStorage.getItem("LineXuan");
    },
    getLineShu: (state) => {
      return state.LineShu || sessionStorage.getItem("LineShu");
    },
    getListXuan: (state) => {
      return state.ListXuan || sessionStorage.getItem("ListXuan");
    },
    getPageXuan: (state) => {
      return state.PageXuan || sessionStorage.getItem("PageXuan");
    },
    getInputXuan: (state) => {
      return state.InputXuan || sessionStorage.getItem("InputXuan");
    },
    getInputZhao: (state) => {
      return state.InputZhao || sessionStorage.getItem("InputZhao");
    },
    getYueId: (state) => {
      return state.YueId || sessionStorage.getItem("YueId");
    },
    getVideourl: (state) => {
      return state.Videourl || sessionStorage.getItem("Videourl");
    },
    getListActivity: (state) => {
      return state.ListActivity || sessionStorage.getItem("ListActivity");
    },
    getPageActivity: (state) => {
      return state.PageActivity || sessionStorage.getItem("PageActivity");
    },
    getInputActivity: (state) => {
      return state.InputActivity || sessionStorage.getItem("InputActivity");
    },
    getIndex: (state) => {
      return state.Index || sessionStorage.getItem("Index");
    },
    getIndex1: (state) => {
      return state.Index1 || sessionStorage.getItem("Index1");
    },
    getIIndex: (state) => {
      return state.IIndex || sessionStorage.getItem("IIndex");
    },
    getIIndex1: (state) => {
      return state.IIndex1 || sessionStorage.getItem("IIndex1");
    },
    getNewsId: (state) => {
      return state.NewsId || sessionStorage.getItem("NewsId");
    },
    getCOMPONENTS: (state) => {
      return state.catch_components || localStorage.getItem("catch_components");
    },
  },
  modules: {},
});



// WEBPACK FOOTER //
// ./src/store.js